function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTypescript = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("rect", {
  width: 28,
  height: 28,
  x: 2,
  y: 2,
  rx: 1.312,
  style: {
    fill: "#3178c6"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.245 23.759v3.068a6.5 6.5 0 0 0 1.764.575 11.6 11.6 0 0 0 2.146.192 10 10 0 0 0 2.088-.211 5.1 5.1 0 0 0 1.735-.7 3.54 3.54 0 0 0 1.181-1.266 4.47 4.47 0 0 0 .186-3.394 3.4 3.4 0 0 0-.717-1.117 5.2 5.2 0 0 0-1.123-.877 12 12 0 0 0-1.477-.734q-.6-.249-1.08-.484a5.5 5.5 0 0 1-.813-.479 2.1 2.1 0 0 1-.516-.518 1.1 1.1 0 0 1-.181-.618 1.04 1.04 0 0 1 .162-.571 1.4 1.4 0 0 1 .459-.436 2.4 2.4 0 0 1 .726-.283 4.2 4.2 0 0 1 .956-.1 6 6 0 0 1 .808.058 6 6 0 0 1 .856.177 6 6 0 0 1 .836.3 4.7 4.7 0 0 1 .751.422V13.9a7.5 7.5 0 0 0-1.525-.4 12.4 12.4 0 0 0-1.9-.129 8.8 8.8 0 0 0-2.064.235 5.2 5.2 0 0 0-1.716.733 3.66 3.66 0 0 0-1.171 1.271 3.73 3.73 0 0 0-.431 1.845 3.6 3.6 0 0 0 .789 2.34 6 6 0 0 0 2.395 1.639q.63.26 1.175.509a6.5 6.5 0 0 1 .942.517 2.5 2.5 0 0 1 .626.585 1.2 1.2 0 0 1 .23.719 1.1 1.1 0 0 1-.144.552 1.3 1.3 0 0 1-.435.441 2.4 2.4 0 0 1-.726.292 4.4 4.4 0 0 1-1.018.105 5.8 5.8 0 0 1-1.969-.35 5.9 5.9 0 0 1-1.805-1.045m-5.154-7.638h4v-2.527H5.938v2.527H9.92v11.254h3.171Z",
  style: {
    fill: "#fff",
    fillRule: "evenodd"
  }
}));
export default SvgTypescript;